import { scaleSequential, scaleOrdinal, scaleLinear, scaleQuantile } from 'd3-scale';
import { interpolateBuGn, interpolateBuPu, interpolateGnBu, interpolateOrRd, interpolatePuBuGn, interpolatePuBu, interpolatePuRd, interpolateRdPu, interpolateYlGnBu, interpolateYlGn, interpolateYlOrBr, interpolateYlOrRd, interpolateBlues, interpolateGreens, interpolateGreys, interpolatePurples, interpolateReds, interpolateOranges, interpolateViridis, interpolateInferno, interpolateMagma, interpolatePlasma, interpolateWarm, interpolateCool, interpolateRainbow, interpolateCubehelixDefault, interpolateBrBG, interpolatePRGn, interpolatePiYG, interpolatePuOr, interpolateRdBu, interpolateRdGy, interpolateRdYlBu, interpolateRdYlGn, interpolateSpectral, schemeAccent, schemeDark2, schemePaired, schemePastel1, schemePastel2, schemeSet1, schemeSet2, schemeSet3, schemeCategory10 } from 'd3-scale-chromatic';
import { range, extent, ascending, max } from 'd3-array';
import { dispatch } from 'd3-dispatch';
import { voronoi } from 'd3-voronoi';
import { quadtree } from 'd3-quadtree';
import { select } from 'd3-selection';
import { hsl } from 'd3-color';

var version = "2.0.4";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Built-in value references. */
var _Symbol = root.Symbol;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag$1 && symToStringTag$1 in Object(value) ? getRawTag(value) : objectToString(value);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return value != null && (type == 'object' || type == 'function');
}

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
}

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
}

/* taken from https://simplestatistics.org/ */

/**
 * Given an array of x, this will find the extent of the
 * x and return an array of breaks that can be used
 * to categorize the x into a number of classes. The
 * returned array will always be 1 longer than the number of
 * classes because it includes the minimum value.
 *
 * @param {Array<number>} x an array of number values
 * @param {number} nClasses number of desired classes
 * @returns {Array<number>} array of class break positions
 * @example
 * equalIntervalBreaks([1, 2, 3, 4, 5, 6], 4); //= [1, 2.25, 3.5, 4.75, 6]
 */
var equalIntervalBreaks = function equalIntervalBreaks(x /*: Array<number> */
, nClasses /*:number*/
) /*: Array<number> */{
  if (x.length < 2) {
    return x;
  }

  var theMin = Math.min.apply(Math, toConsumableArray(x)),
      theMax = Math.max.apply(Math, toConsumableArray(x));

  // the first break will always be the minimum value
  // in the xset
  var breaks = [theMin];

  // The size of each break is the full range of the x
  // divided by the number of classes requested
  var breakSize = (theMax - theMin) / nClasses;

  // In the case of nClasses = 1, this loop won't run
  // and the returned breaks will be [min, max]
  for (var i = 1; i < nClasses; i++) {
    breaks.push(breaks[0] + breakSize * i);
  }

  // the last break will always be the
  // maximum.
  breaks.push(theMax);

  return breaks;
};

var SchemeReds = 'Reds';
var SchemeBlues = 'Blues';
var SchemeGreens = 'Greens';
var SchemeGreys = 'Greys';
var SchemeOranges = 'Oranges';
var SchemePurples = 'Purples';
var SchemeBuGn = 'BuGn';
var SchemeBuPu = 'BuPu';
var SchemeGnBu = 'GnBu';
var SchemeOrRd = 'OrRd';
var SchemePuBuGn = 'PuBuGn';
var SchemePuBu = 'PuBu';
var SchemePuRd = 'PuRd';
var SchemeRdPu = 'RdPu';
var SchemeYlGnBu = 'YlGnBu';
var SchemeYlGn = 'YlGn';
var SchemeYlOrBr = 'YlOrBr';
var SchemeYlOrRd = 'YlOrRd';
var SchemeViridis = 'Viridis';
var SchemeInferno = 'Inferno';
var SchemeMagma = 'Magma';
var SchemePlasma = 'Plasma';
var SchemeWarm = 'Warm';
var SchemeCool = 'Cool';
var SchemeRainbow = 'Rainbow';
var SchemeCubehelix = 'Cubehelix';

var interpolateSequentialScheme = function interpolateSequentialScheme(_scheme) {
  if (!isFunction(_scheme) && !isString(_scheme)) {
    throw new Error(_scheme + 'is invalid');
  }

  // user specified interpolator
  if (isFunction(_scheme)) {
    return _scheme;
  }

  //shortcode for internal interpolators
  switch (_scheme) {
    // sequential single hue
    case SchemeBlues:
      return interpolateBlues;

    case SchemeGreens:
      return interpolateGreens;

    case SchemeGreys:
      return interpolateGreys;

    case SchemeOranges:
      return interpolateOranges;

    case SchemeReds:
      return interpolateReds;

    case SchemePurples:
      return interpolatePurples;

    // Sequential (Multi-Hue)
    case SchemeBuGn:
      return interpolateBuGn;

    case SchemeBuPu:
      return interpolateBuPu;

    case SchemeGnBu:
      return interpolateGnBu;

    case SchemeOrRd:
      return interpolateOrRd;

    case SchemePuBuGn:
      return interpolatePuBuGn;

    case SchemePuBu:
      return interpolatePuBu;

    case SchemePuRd:
      return interpolatePuRd;

    case SchemeRdPu:
      return interpolateRdPu;

    case SchemeYlGnBu:
      return interpolateYlGnBu;

    case SchemeYlGn:
      return interpolateYlGn;

    case SchemeYlOrBr:
      return interpolateYlOrBr;

    case SchemeYlOrRd:
      return interpolateYlOrRd;

    // R Color
    case SchemeViridis:
      return interpolateViridis;

    case SchemeInferno:
      return interpolateInferno;

    case SchemeMagma:
      return interpolateMagma;

    case SchemePlasma:
      return interpolatePlasma;

    case SchemeWarm:
      return interpolateWarm;

    case SchemeCool:
      return interpolateCool;

    case SchemeRainbow:
      return interpolateRainbow;

    case SchemeCubehelix:
      return interpolateCubehelixDefault;

    default:
      return null;
  }
};

var linearStops = function linearStops(scheme) {
  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  if (isString(scheme) || isFunction(scheme)) {
    var interpolator = interpolateSequentialScheme(scheme);

    var offsets = range(0, 1, 0.1);
    offsets.push(1); // range is 0-0.9

    if (interpolator != null) {
      var seqScale = scaleSequential(interpolator).domain([0, 1]); // explicit domain, not really need to do so

      return offsets.map(function (d) {
        return {
          offset: d,
          color: seqScale(d)
        };
      });
    } else {
      // fade out a single hue
      return offsets.map(function (d) {
        var _hsl = hsl(scheme);
        _hsl.opacity = opacity * d;

        return {
          offset: d,
          color: _hsl
        };
      });
    }
  } else if (isArray(scheme)) {
    var count = scheme.length;

    if (count > 1) {
      var steps = equalIntervalBreaks([0, 1], count - 1);

      return steps.map(function (d, i) {
        return {
          offset: d,
          color: scheme[i]
        };
      });
    } else {
      console.log('linear gradient requires at least two colors');
    }
  }
};

var SchemeAccent = 'Accent';
var SchemeDark2 = 'Dark2';
var SchemePaired = 'Paired';
var SchemePastel1 = 'Pastel1';
var SchemePastel2 = 'Pastel2';
var SchemeSet1 = 'Set1';
var SchemeSet2 = 'Set2';
var SchemeSet3 = 'Set3';
var SchemeCategory10 = 'Category10';

var SchemeBrBG = 'BrBG';
var SchemePRGn = 'PRGn';
var SchemePiYG = 'PiYG';
var SchemePuOr = 'PuOr';
var SchemeRdBu = 'RdBu';
var SchemeRdGy = 'RdGy';
var SchemeRdYlBu = 'RdYlBu';
var SchemeRdYlGn = 'RdYlGn';
var SchemeSpectral = 'Spectral';

var AllHcl = {
  name: 'All colors',
  dark: false,
  clbl: false,
  hmin: 0,
  hmax: 360,
  cmin: 0,
  cmax: 100,
  lmin: 0,
  lmax: 100
};

var DefaultColorSpace = {
  name: 'Default preset',
  dark: false,
  clbl: false,
  hmin: 0,
  hmax: 360,
  cmin: 30,
  cmax: 80,
  lmin: 35,
  lmax: 80
};

var ColorBlind = {
  name: 'Colorblind friendly',
  dark: false,
  clbl: true,
  hmin: 0,
  hmax: 360,
  cmin: 40,
  cmax: 70,
  lmin: 15,
  lmax: 85
};

var FancyLight = {
  name: 'Fancy (light background)',
  dark: false,
  clbl: false,
  hmin: 0,
  hmax: 360,
  cmin: 15,
  cmax: 40,
  lmin: 70,
  lmax: 100
};

var FancyDark = {
  name: 'Fancy (dark background)',
  dark: true,
  clbl: false,
  hmin: 0,
  hmax: 360,
  cmin: 8,
  cmax: 40,
  lmin: 7,
  lmax: 40
};

var Tarnish = {
  name: 'Tarnish',
  dark: false,
  clbl: false,
  hmin: 0,
  hmax: 360,
  cmin: 0,
  cmax: 15,
  lmin: 30,
  lmax: 70
};

var Pastel = {
  name: 'Pastel',
  dark: false,
  clbl: false,
  hmin: 0,
  hmax: 360,
  cmin: 0,
  cmax: 30,
  lmin: 70,
  lmax: 100
};

var Pimp = {
  name: 'Pimp',
  dark: false,
  clbl: false,
  hmin: 0,
  hmax: 360,
  cmin: 30,
  cmax: 100,
  lmin: 25,
  lmax: 70
};

var Intense = {
  name: 'Intense',
  dark: false,
  clbl: false,
  hmin: 0,
  hmax: 360,
  cmin: 20,
  cmax: 100,
  lmin: 15,
  lmax: 80
};

var Fluo = {
  name: 'Fluo',
  dark: true,
  clbl: false,
  hmin: 0,
  hmax: 300,
  cmin: 35,
  cmax: 100,
  lmin: 75,
  lmax: 100
};

var RedRoses = {
  name: 'Red Roses',
  dark: true,
  clbl: false,
  hmin: 330,
  hmax: 20,
  cmin: 10,
  cmax: 100,
  lmin: 35,
  lmax: 100
};

var OchreSand = {
  name: 'Ochre Sand',
  dark: true,
  clbl: false,
  hmin: 20,
  hmax: 60,
  cmin: 20,
  cmax: 50,
  lmin: 35,
  lmax: 100
};

var YellowLime = {
  name: 'Yellow Lime',
  dark: true,
  clbl: false,
  hmin: 60,
  hmax: 90,
  cmin: 10,
  cmax: 100,
  lmin: 35,
  lmax: 100
};

var GreenMint = {
  name: 'Green Mint',
  dark: true,
  clbl: false,
  hmin: 90,
  hmax: 150,
  cmin: 10,
  cmax: 100,
  lmin: 35,
  lmax: 100
};

var IceCube = {
  name: 'Ice Cube',
  dark: true,
  clbl: false,
  hmin: 150,
  hmax: 200,
  cmin: 0,
  cmax: 100,
  lmin: 35,
  lmax: 100
};

var BlueOcean = {
  name: 'Blue Ocean',
  dark: true,
  clbl: false,
  hmin: 220,
  hmax: 260,
  cmin: 8,
  cmax: 80,
  lmin: 0,
  lmax: 50
};

var IndigoNight = {
  name: 'Indigo Night',
  dark: true,
  clbl: false,
  hmin: 260,
  hmax: 290,
  cmin: 40,
  cmax: 100,
  lmin: 35,
  lmax: 100
};

var PurpleWine = {
  name: 'Purple Wine',
  dark: true,
  clbl: false,
  hmin: 290,
  hmax: 330,
  cmin: 0,
  cmax: 100,
  lmin: 0,
  lmax: 40
};

// cold, dark metropolis

var MetroCold3 = ['#1bcebf', '#1572ca', '#5f26c1'];

var MetroCold4 = ['#1bcebf', '#24bbd2', '#1572ca', '#5f26c1'];

var MetroCold5 = ['#1bcebf', '#24bbd2', '#1572ca', '#1f33a1', '#5f26c1'];

var MetroDawn3 = ['#ffe100', '#ffbf00', '#ff5730'];

var MetroDawn4 = ['#ffe100', '#ffbf00', '#ff5730', '#eb3ba6'];

var MetroRain3 = ['#79e70f', '#10d9ec', '#1f97e7'];

var MetroRain8 = ['#abe70f', '#79e70f', '#0fe71f', '#0fe7d4', '#10d9ec', '#10c5ec', '#1fb2e7', '#1f97e7'];

/**
 * Ellsworth Kelly's Spectrum V in the Met
 * http://www.metmuseum.org/art/collection/search/489800
 *
 */
var TheMetDark = ['#947702', '#57781d', '#38753c', '#115b5e', '#395558', '#49424a', '#603830', '#6e3e58', '#9a4143', '#ac3e1b', '#a84502', '#ab4400', '#b45800', '#9b6f00'];

var TheMetLight = ['#F44336', '#E91E63', '#9C27B0', '#673AB7', '#3F51B5', '#2196F3', '#03A9F4', '#00BCD4', '#009688', '#4CAF50', '#8BC34A', '#CDDC39', '#FFEB3B', '#FFC107', '#FF9800', '#FF5722'];

/* taken from https://simplestatistics.org/ */

/**
 * For a sorted input, counting the number of unique values
 * is possible in constant time and constant memory. This is
 * a simple implementation of the algorithm.
 *
 * Values are compared with `===`, so objects and non-primitive objects
 * are not handled in any special way.
 *
 * @param {Array<*>} x an array of any kind of value
 * @returns {number} count of unique values
 * @example
 * uniqueCountSorted([1, 2, 3]); // => 3
 * uniqueCountSorted([1, 1, 1]); // => 1
 */
var uniqueCountSorted = function uniqueCountSorted(x /*: Array<any>*/) /*: number */{
  var uniqueValueCount = 0,
      lastSeenValue = void 0;
  for (var i = 0; i < x.length; i++) {
    if (i === 0 || x[i] !== lastSeenValue) {
      lastSeenValue = x[i];
      uniqueValueCount++;
    }
  }
  return uniqueValueCount;
};

/* taken from https://simplestatistics.org/ */

/**
 * Sort an array of numbers by their numeric value, ensuring that the
 * array is not changed in place.
 *
 * This is necessary because the default behavior of .sort
 * in JavaScript is to sort arrays as string values
 *
 *     [1, 10, 12, 102, 20].sort()
 *     // output
 *     [1, 10, 102, 12, 20]
 *
 * @param {Array<number>} x input array
 * @return {Array<number>} sorted array
 * @private
 * @example
 * numericSort([3, 2, 1]) // => [1, 2, 3]
 */
var numericSort = function numericSort(x /*: Array<number> */) /*: Array<number> */{
  return x
  // ensure the array is not changed in-place
  .slice()
  // comparator function that treats input as numeric
  .sort(function (a, b) {
    return a - b;
  });
};

/* taken from https://simplestatistics.org/ */

/**
 * Create a new column x row matrix.
 *
 * @private
 * @param {number} columns
 * @param {number} rows
 * @return {Array<Array<number>>} matrix
 * @example
 * makeMatrix(10, 10);
 */
function makeMatrix(columns, rows) {
  var matrix = [];
  for (var i = 0; i < columns; i++) {
    var column = [];
    for (var j = 0; j < rows; j++) {
      column.push(0);
    }
    matrix.push(column);
  }
  return matrix;
}

/**
 * Generates incrementally computed values based on the sums and sums of
 * squares for the data array
 *
 * @private
 * @param {number} j
 * @param {number} i
 * @param {Array<number>} sums
 * @param {Array<number>} sumsOfSquares
 * @return {number}
 * @example
 * ssq(0, 1, [-1, 0, 2], [1, 1, 5]);
 */
function ssq(j, i, sums, sumsOfSquares) {
  var sji = void 0; // s(j, i)
  if (j > 0) {
    var muji = (sums[i] - sums[j - 1]) / (i - j + 1); // mu(j, i)
    sji = sumsOfSquares[i] - sumsOfSquares[j - 1] - (i - j + 1) * muji * muji;
  } else {
    sji = sumsOfSquares[i] - sums[i] * sums[i] / (i + 1);
  }
  if (sji < 0) {
    return 0;
  }
  return sji;
}

/**
 * Function that recursively divides and conquers computations
 * for cluster j
 *
 * @private
 * @param {number} iMin Minimum index in cluster to be computed
 * @param {number} iMax Maximum index in cluster to be computed
 * @param {number} cluster Index of the cluster currently being computed
 * @param {Array<Array<number>>} matrix
 * @param {Array<Array<number>>} backtrackMatrix
 * @param {Array<number>} sums
 * @param {Array<number>} sumsOfSquares
 */
function fillMatrixColumn(iMin, iMax, cluster, matrix, backtrackMatrix, sums, sumsOfSquares) {
  if (iMin > iMax) {
    return;
  }

  // Start at midpoint between iMin and iMax
  var i = Math.floor((iMin + iMax) / 2);

  matrix[cluster][i] = matrix[cluster - 1][i - 1];
  backtrackMatrix[cluster][i] = i;

  var jlow = cluster; // the lower end for j

  if (iMin > cluster) {
    jlow = Math.max(jlow, backtrackMatrix[cluster][iMin - 1] || 0);
  }
  jlow = Math.max(jlow, backtrackMatrix[cluster - 1][i] || 0);

  var jhigh = i - 1; // the upper end for j
  if (iMax < matrix.length - 1) {
    jhigh = Math.min(jhigh, backtrackMatrix[cluster][iMax + 1] || 0);
  }

  var sji = void 0;
  var sjlowi = void 0;
  var ssqjlow = void 0;
  var ssqj = void 0;
  for (var j = jhigh; j >= jlow; --j) {
    sji = ssq(j, i, sums, sumsOfSquares);

    if (sji + matrix[cluster - 1][jlow - 1] >= matrix[cluster][i]) {
      break;
    }

    // Examine the lower bound of the cluster border
    sjlowi = ssq(jlow, i, sums, sumsOfSquares);

    ssqjlow = sjlowi + matrix[cluster - 1][jlow - 1];

    if (ssqjlow < matrix[cluster][i]) {
      // Shrink the lower bound
      matrix[cluster][i] = ssqjlow;
      backtrackMatrix[cluster][i] = jlow;
    }
    jlow++;

    ssqj = sji + matrix[cluster - 1][j - 1];
    if (ssqj < matrix[cluster][i]) {
      matrix[cluster][i] = ssqj;
      backtrackMatrix[cluster][i] = j;
    }
  }

  fillMatrixColumn(iMin, i - 1, cluster, matrix, backtrackMatrix, sums, sumsOfSquares);
  fillMatrixColumn(i + 1, iMax, cluster, matrix, backtrackMatrix, sums, sumsOfSquares);
}

/**
 * Initializes the main matrices used in Ckmeans and kicks
 * off the divide and conquer cluster computation strategy
 *
 * @private
 * @param {Array<number>} data sorted array of values
 * @param {Array<Array<number>>} matrix
 * @param {Array<Array<number>>} backtrackMatrix
 */
function fillMatrices(data, matrix, backtrackMatrix) {
  var nValues = matrix[0].length;

  // Shift values by the median to improve numeric stability
  var shift = data[Math.floor(nValues / 2)];

  // Cumulative sum and cumulative sum of squares for all values in data array
  var sums = [];
  var sumsOfSquares = [];

  // Initialize first column in matrix & backtrackMatrix
  for (var i = 0, shiftedValue; i < nValues; ++i) {
    shiftedValue = data[i] - shift;
    if (i === 0) {
      sums.push(shiftedValue);
      sumsOfSquares.push(shiftedValue * shiftedValue);
    } else {
      sums.push(sums[i - 1] + shiftedValue);
      sumsOfSquares.push(sumsOfSquares[i - 1] + shiftedValue * shiftedValue);
    }

    // Initialize for cluster = 0
    matrix[0][i] = ssq(0, i, sums, sumsOfSquares);
    backtrackMatrix[0][i] = 0;
  }

  // Initialize the rest of the columns
  var iMin = void 0;
  for (var cluster = 1; cluster < matrix.length; ++cluster) {
    if (cluster < matrix.length - 1) {
      iMin = cluster;
    } else {
      // No need to compute matrix[K-1][0] ... matrix[K-1][N-2]
      iMin = nValues - 1;
    }

    fillMatrixColumn(iMin, nValues - 1, cluster, matrix, backtrackMatrix, sums, sumsOfSquares);
  }
}

/**
 * Ckmeans clustering is an improvement on heuristic-based clustering
 * approaches like Jenks. The algorithm was developed in
 * [Haizhou Wang and Mingzhou Song](http://journal.r-project.org/archive/2011-2/RJournal_2011-2_Wang+Song.pdf)
 * as a [dynamic programming](https://en.wikipedia.org/wiki/Dynamic_programming) approach
 * to the problem of clustering numeric data into groups with the least
 * within-group sum-of-squared-deviations.
 *
 * Minimizing the difference within groups - what Wang & Song refer to as
 * `withinss`, or within sum-of-squares, means that groups are optimally
 * homogenous within and the data is split into representative groups.
 * This is very useful for visualization, where you may want to represent
 * a continuous variable in discrete color or style groups. This function
 * can provide groups that emphasize differences between data.
 *
 * Being a dynamic approach, this algorithm is based on two matrices that
 * store incrementally-computed values for squared deviations and backtracking
 * indexes.
 *
 * This implementation is based on Ckmeans 3.4.6, which introduced a new divide
 * and conquer approach that improved runtime from O(kn^2) to O(kn log(n)).
 *
 * Unlike the [original implementation](https://cran.r-project.org/web/packages/Ckmeans.1d.dp/index.html),
 * this implementation does not include any code to automatically determine
 * the optimal number of clusters: this information needs to be explicitly
 * provided.
 *
 * ### References
 * _Ckmeans.1d.dp: Optimal k-means Clustering in One Dimension by Dynamic
 * Programming_ Haizhou Wang and Mingzhou Song ISSN 2073-4859
 *
 * from The R Journal Vol. 3/2, December 2011
 * @param {Array<number>} x input data, as an array of number values
 * @param {number} nClusters number of desired classes. This cannot be
 * greater than the number of values in the data array.
 * @returns {Array<Array<number>>} clustered input
 * @throws {Error} if the number of requested clusters is higher than the size of the data
 * @example
 * ckmeans([-1, 2, -1, 2, 4, 5, 6, -1, 2, -1], 3);
 * // The input, clustered into groups of similar numbers.
 * //= [[-1, -1, -1, -1], [2, 2, 2], [4, 5, 6]]);
 */
var ckmeans = function ckmeans(x /*: Array<number> */
, nClusters /*: number */
) /*: Array<Array<number>> */{
  if (nClusters > x.length) {
    throw new Error('cannot generate more classes than there are data values');
  }

  var sorted = numericSort(x),

  // we'll use this as the maximum number of clusters
  uniqueCount = uniqueCountSorted(sorted);

  // if all of the input values are identical, there's one cluster
  // with all of the input in it.
  if (uniqueCount === 1) {
    return [sorted];
  }

  // named 'S' originally
  var matrix = makeMatrix(nClusters, sorted.length),

  // named 'J' originally
  backtrackMatrix = makeMatrix(nClusters, sorted.length);

  // This is a dynamic programming way to solve the problem of minimizing
  // within-cluster sum of squares. It's similar to linear regression
  // in this way, and this calculation incrementally computes the
  // sum of squares that are later read.
  fillMatrices(sorted, matrix, backtrackMatrix);

  // The real work of Ckmeans clustering happens in the matrix generation:
  // the generated matrices encode all possible clustering combinations, and
  // once they're generated we can solve for the best clustering groups
  // very quickly.
  var clusters = [],
      clusterRight = backtrackMatrix[0].length - 1;

  // Backtrack the clusters from the dynamic programming matrix. This
  // starts at the bottom-right corner of the matrix (if the top-left is 0, 0),
  // and moves the cluster target with the loop.
  for (var cluster = backtrackMatrix.length - 1; cluster >= 0; cluster--) {
    var clusterLeft = backtrackMatrix[cluster][clusterRight];

    // fill the cluster from the sorted input by taking a slice of the
    // array. the backtrack matrix makes this easy - it stores the
    // indexes where the cluster should start and end.
    clusters[cluster] = sorted.slice(clusterLeft, clusterRight + 1);

    if (cluster > 0) {
      clusterRight = clusterLeft - 1;
    }
  }

  return clusters;
};

var warn = function warn(msg) {
  if (console) {
    console.warn(msg);
  }
};

var _smartSequential = function _smartSequential(_scheme, _data) {
  var _scale = scaleLinear();

  var schemeLen = _scheme.length;
  var dataLen = _data.length;

  var theDarkest = _scheme[schemeLen - 1];

  if (schemeLen === 0) ; else if (dataLen === 1) {
    // use the darkest
    _scale = scaleOrdinal().domain(_data[0]).range([theDarkest]);
  } else if (dataLen === schemeLen) {
    // use every single color
    _scale.domain(_data).range(_scheme);
  } else if (dataLen < schemeLen) {
    // sort data from the smallest to the largest

    var _trimmed = new Array(dataLen);

    for (var i = dataLen - 2; i > 0; i--) {
      _trimmed[i] = _scheme[i];
    }

    _trimmed[0] = _scheme[0];
    _trimmed[dataLen - 1] = theDarkest;

    _scale.domain(_data).range(_trimmed);
  } else {
    // use kmeans
    var clusters = ckmeans(_data, schemeLen - 1);
    var breakpoints = clusters.map(function (d) {
      return d[d.length - 1];
    });
    var _domain = [clusters[0][0]].concat(breakpoints);

    _scale.domain(_domain).range(_scheme);
  }

  return _scale;
};

var gradientColor = function gradientColor(scheme, _data) {
  var _scheme = void 0;

  if (!isString(scheme) && !isArray(scheme) && !isFunction(scheme)) {
    warn('color scheme is invalid: should be string, array or d3 interpolator');
    warn('MetroRain3 will be used by default');
    _scheme = MetroRain3;
  } else {
    _scheme = scheme;
  }

  if (isString(_scheme)) {
    var _interpolated = interpolateSequentialScheme(_scheme);
    if (_interpolated === null) {
      warn('color scheme is not found');
      warn('MetroRain3 will be used by default');
      _scheme = MetroRain3;

      return _smartSequential(_scheme, _data);
    } else {
      return scaleSequential(_interpolated).domain(extent(_data));
    }
  } else if (isFunction(_scheme)) {
    return scaleSequential(_scheme).domain(extent(_data));
  } else if (isArray(_scheme)) {
    return _smartSequential(_scheme, _data);
  }
};

var _distinctStops = function _distinctStops(scheme, distinction) {
  var _color = scaleSequential(scheme).domain(extent(distinction));
  return distinction.sort(ascending).map(function (d) {
    return _color(d);
  });
};

var distinctColor = function distinctColor(scheme) {
  var distinction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [0, 0.33, 0.66, 1];

  if (distinction.length < 2) {
    warn('distinction  must contains at least 3 elements, [0, 0.33, 0.66, 1] will be used by default');
  }

  var _distinction = distinction.length < 2 ? [0, 0.33, 0.66, 1] : distinction;

  var _scheme = void 0;

  if (!isString(scheme) && !isArray(scheme) && !isFunction(scheme)) {
    warn('color scheme is invalid: should be string, array or d3 interpolator');
    warn(' MetroRain3 will be used by default');
    _scheme = MetroRain3;
  } else {
    _scheme = scheme;
  }

  var _scale = scaleQuantile().domain(_distinction);

  if (isString(_scheme)) {
    var _interpolated = interpolateSequentialScheme(_scheme);

    if (_interpolated === null) {
      warn('color scheme is not found');
      warn('MetroRain3 will be used by default');

      _scheme = MetroRain3;
      _scale.range(_scheme);
    } else {
      _scale.range(_distinctStops(_interpolated, _distinction));
    }
  } else if (isFunction(_scheme)) {
    _scale.range(_distinctStops(_scheme, _distinction));
  } else if (isArray(_scheme)) {
    _scale.range(_scheme);
  }

  return _scale;
};

var interpolateDivergentScheme = function interpolateDivergentScheme(_scheme) {
  switch (_scheme) {
    // categorical
    case SchemeBrBG:
      return interpolateBrBG;

    case SchemePRGn:
      return interpolatePRGn;

    case SchemePiYG:
      return interpolatePiYG;

    case SchemePuOr:
      return interpolatePuOr;

    case SchemeRdBu:
      return interpolateRdBu;

    case SchemeRdGy:
      return interpolateRdGy;

    case SchemeRdYlBu:
      return interpolateRdYlBu;

    case SchemeRdYlGn:
      return interpolateRdYlGn;

    case SchemeSpectral:
      return interpolateSpectral;

    default:
      return null;
  }
};

var divergentColor = function divergentColor(scheme) {
  warn('divergent not implemented yet');

  var _scheme = void 0;
  if (!isString(scheme) && !isArray(scheme) && !isFunction(scheme)) {
    warn('color scheme is invalid: should be string, array or d3 interpolator');
    warn('SchemeRdYlGn will be used by default');
    _scheme = SchemeRdYlGn;
  } else {
    _scheme = scheme;
  }

  if (isString(_scheme)) {
    var _interpolated = interpolateDivergentScheme(_scheme);

    if (_interpolated === null) {
      warn('color scheme is not found');
      warn('SchemeRdYlGn will be used by default');

      _scheme = SchemeRdYlGn;
      return scaleSequential(interpolateDivergentScheme(_scheme));
    } else {
      return scaleSequential(_interpolated);
    }
  } else if (isFunction(_scheme)) {
    return scaleSequential(_scheme);
  } else {
    return null;
  }
};

var interpolateCategoricalScheme = function interpolateCategoricalScheme(_scheme) {
  switch (_scheme) {
    // categorical
    case SchemeAccent:
      return schemeAccent;

    case SchemeDark2:
      return schemeDark2;

    case SchemePaired:
      return schemePaired;

    case SchemePastel1:
      return schemePastel1;

    case SchemePastel2:
      return schemePastel2;

    case SchemeSet1:
      return schemeSet1;

    case SchemeSet2:
      return schemeSet2;

    case SchemeSet3:
      return schemeSet3;

    // categorical
    case SchemeCategory10:
      return schemeCategory10;

    default:
      return null;
  }
};

var _selectFromScheme = function _selectFromScheme(interpolator, distinction) {
  var scale = scaleSequential(interpolator);

  if (distinction <= 1) {
    return scale(1);
  } else {
    //https://github.com/d3/d3-array#range
    return range(distinction).map(function (d) {
      return scale(d / (distinction - 1));
    });
  }
};

var categoricalColor = function categoricalColor(scheme) {
  var distinction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (!isString(scheme) && !isArray(scheme) && !isFunction(scheme)) {
    warn('color scheme is invalid: should be string, array or d3 interpolator');
    warn('MetroRain8 will be used by default');
    scheme = MetroRain8;
  }

  var selectNum = distinction <= 1 ? 12 : distinction;
  // warn('categorical number is invalid: should be larger than 0');
  // warn('12 will be used by default');

  if (isString(scheme)) {
    var colorSet = interpolateCategoricalScheme(scheme) || interpolateSequentialScheme(scheme) || interpolateDivergentScheme(scheme);

    if (colorSet != null) {
      if (isArray(colorSet)) {
        return scaleOrdinal().range(colorSet);
      } else {
        return scaleOrdinal().range(_selectFromScheme(colorSet, selectNum));
      }
    } else {
      return scaleOrdinal().range(MetroRain8);
    }
  } else if (isFunction(scheme)) {
    return scaleOrdinal().range(_selectFromScheme(scheme, selectNum));
  } else {
    return scaleOrdinal().range(scheme);
  }
};

var Globals = {
  DataType: {
    DATE: 'date',
    NUMBER: 'number',
    STRING: 'string'
  },

  ColorType: {
    GRADIENT: 'gradient',
    DISTINCT: 'distinct',
    CATEGORICAL: 'categorical',
    DIVERGENT: 'divergent'
  }
};

var genericColor = function genericColor(color, data) {
  var _scheme = color.scheme;
  var _type = color.type;

  switch (_type) {
    case Globals.ColorType.GRADIENT:
      return gradientColor(_scheme, data);

    case Globals.ColorType.DISTINCT:
      var _valMap = data ? color.distinction.map(function (d) {
        return max(data) * +d;
      }) : color.distinction;

      return distinctColor(_scheme, _valMap);

    case Globals.ColorType.DIVERGENT:
      return divergentColor(_scheme, data);

    case Globals.ColorType.CATEGORICAL:
      return categoricalColor(_scheme);

    default:
      warn('color type should be gradient, distinct, divergent or categorical');
      break;
  }
};

var DefaultDataComposer = function DefaultDataComposer(data, opt, cleanse) {
    return data;
};
var DefaultColorComposer = function DefaultColorComposer(color, data, opt) {
    return genericColor(color);
};

var makeComposers = function makeComposers(comp) {
    return {
        opt: comp.opt || null,
        data: comp.data || DefaultDataComposer,
        color: comp.color || DefaultColorComposer
    };
};

var apiOn = function apiOn(state) {
  return {
    on: function on(name, callback) {
      state._listeners.on(name, callback);
    }
  };
};

var apiColor = function apiColor(state) {
  return {
    color: function color(_color) {
      state._options.color = _color;
      state._color = genericColor(_color);
    }
  };
};

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
    objectProto$2 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$2.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString$1.call(hasOwnProperty$1).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty$2.call(data, key) ? data[key] : undefined;
}

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty$3.call(data, key);
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED$1 : value;
  return this;
}

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map || ListCache)(),
    'string': new Hash()
  };
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

var defineProperty$1 = function () {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty$1) {
    defineProperty$1(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function (object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/** Detect free variable `exports`. */
var freeExports = (typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && (typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = function () {
  function object() {}
  return function (proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$5;

  return value === proto;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$6.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$6.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function () {
  return arguments;
}()) ? baseIsArguments : function (value) {
  return isObjectLike(value) && hasOwnProperty$4.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/** Detect free variable `exports`. */
var freeExports$1 = (typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$1 = freeExports$1 && (typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;

/** Built-in value references. */
var Buffer$1 = moduleExports$1 ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer$1 ? Buffer$1.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto$2 = Function.prototype,
    objectProto$7 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$7.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString$2.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$5.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString$2.call(Ctor) == objectCtorString;
}

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag$1 = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag$1 = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag$1] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag$1] = typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

/** Detect free variable `exports`. */
var freeExports$2 = (typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$2 = freeExports$2 && (typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports$2 && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = function () {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule$2 && freeModule$2.require && freeModule$2.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Gets the value at `key`, unless `key` is "__proto__".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$6.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  length = length == null ? MAX_SAFE_INTEGER$1 : length;

  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$7.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' ||
    // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') ||
    // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$8.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      } else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      } else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      } else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      } else {
        newValue = [];
      }
    } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      } else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    } else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function (srcValue, key) {
    if (isObject(srcValue)) {
      stack || (stack = new Stack());
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    } else {
      var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function () {
    return value;
  };
}

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty$1 ? identity : function (func, string) {
  return defineProperty$1(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function () {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index === 'undefined' ? 'undefined' : _typeof(index);
  if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function (object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function (object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function (object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

var MergeCustomizer = function MergeCustomizer(objValue, srcValue) {
  if (isArray(objValue)) {
    var hasObjDef = false;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = objValue[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var d = _step.value;

        if (isObject(d)) {
          hasObjDef = true;
          break;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    if (hasObjDef === false) {
      // copy rather than concat
      return srcValue;
    } else if (objValue.length === 0) {
      // target is placeholder but not template
      return srcValue;
    } else if (objValue.length === 1) {
      // the single and first value is used as template
      var _template = objValue[0];

      return srcValue.map(function (d) {
        return merge(Object.assign({}, _template), d);
      });
    } else {
      // target has multiple values, all source are merged by index

      return objValue.map(function (d, i) {
        var _tep = Object.assign({}, d);

        if (srcValue.length > i) {
          return merge(_tep, srcValue[i]);
        } else {
          return _tep;
        }
      });
    }
  }
};

var merge$1 = function merge(target, source) {
  if (source === undefined || source === null) return target;

  mergeWith(target, source, MergeCustomizer);

  return target;
};

var apiOptions = function apiOptions(state) {
  return {
    options: function options(opt) {
      state._options = merge$1(state._options, opt);
      return state._options;
    }
  };
};

var apiData = function apiData(state) {
  return {
    data: function data(_data) {
      if (_data !== undefined && _data !== null) {
        state._data = state._composers.data(_data, state._options, true);
      }

      return state._data;
    }
  };
};

var renderSVG = function renderSVG(containerId, opt) {
  var container = select(containerId).append('svg').attr('width', opt.chart.width).attr('height', opt.chart.height).attr('preserveAspectRatio', 'xMinYMin meet').attr('viewBox', '0 0 ' + opt.chart.width + ' ' + opt.chart.height).classed('vizart-chart', true);

  var svg = container.append('g').attr('transform', 'translate(' + opt.chart.margin.left + ',' + opt.chart.margin.top + ')');

  return {
    container: container,
    svg: svg
  };
};

var apiRender = function apiRender(state) {
  return {
    render: function render(data) {
      state._data = state._composers.data(data, state._options, true);
      state._color = state._composers.color(state._options.color, state._data, state._options);

      var _renderSVG = renderSVG(state._containerId, state._options),
          container = _renderSVG.container,
          svg = _renderSVG.svg;

      state._container = container;
      state._svg = svg;
    }
  };
};

var apiUpdate = function apiUpdate(state) {
  return {
    update: function update() {
      state._data = state._composers.data(state._data, state._options, false);
      state._color = state._composers.color(state._options.color, state._data, state._options);
    }
  };
};

var s4 = function s4() {
  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
};

var uuid = function uuid() {
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
};

// isMobile
var isMobile = function isMobile() {
  return (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))
  );
};

var containerWidth = function containerWidth(container) {
  return parseInt(container.node().getBoundingClientRect().width, 10) || 400;
};
var containerHeight = function containerHeight(container) {
  return parseInt(container.node().getBoundingClientRect().height, 10) || 300;
};

/*
 Sanitize and provide default for the container height.
 */
var sanitizeHeight = function sanitizeHeight(container) {
  return container.node() === null ? 0 : containerHeight(container) || 300;
};

/*
 Sanitize and provide default for the container width.
 */
var sanitizeWidth = function sanitizeWidth(container) {
  return container.node() === null ? 0 : containerWidth(container) || 400;
};

var isDefined = function isDefined(d) {
  return d !== undefined && d !== null && !Number.isNaN(d);
};

var assignContainerBound = function assignContainerBound(containerId, opt) {
  var _opt$chart = opt.chart,
      userWidth = _opt$chart.width,
      userHeight = _opt$chart.height,
      _opt$chart$margin = _opt$chart.margin,
      top = _opt$chart$margin.top,
      bottom = _opt$chart$margin.bottom,
      left = _opt$chart$margin.left,
      right = _opt$chart$margin.right;


  var container = select(containerId);

  // check if user setting is valid
  if (isDefined(userWidth)) {
    if (userWidth <= left + right) {
      warn('invalid width setting has been ignored');
      delete opt.chart['width'];
    }
  }

  if (isDefined(userHeight)) {
    if (userHeight <= top + bottom) {
      warn('invalid height setting has been ignored');
      delete opt.chart['height'];
    }
  }

  // user setting has priority
  if (!isDefined(opt.chart.width)) {
    opt.chart.width = sanitizeWidth(container);
  }

  if (!isDefined(opt.chart.height)) {
    opt.chart.height = sanitizeHeight(container);
  }

  opt.chart.innerWidth = opt.chart.width - left - right;
  opt.chart.innerHeight = opt.chart.height - top - bottom;

  return opt;
};

var baseOpt = function baseOpt() {
    return {
        // v1.0
        chart: {
            type: null,
            width: null,
            height: null,
            className: null,
            margin: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            },
            background: {
                color: null,
                opacity: 1
            }
        },
        animation: {
            enabled: true,
            duration: {
                add: 500,
                update: 1000,
                remove: 500,
                color: 500,
                tooltip: 0,
                quickUpdate: 500
            }
        },
        events: {
            render: null,
            update: null,
            drilldown: null,
            drillup: null,
            drillupall: null,
            selection: null
        },
        color: {
            scheme: '', // string or array
            type: '',
            kmeans: true
        },
        plots: {},
        tooltip: {
            className: null,
            enabled: true,
            duration: 500,
            offset: [30, 30],
            formatter: function formatter() {}
        },
        data: {},

        // v2.0
        title: {
            enabled: false,
            text: null,
            style: '',
            align: 'center'
        },

        legend: {
            enabled: false
        }
    };
};

var mergeOptions = function mergeOptions() {
  for (var _len = arguments.length, opts = Array(_len), _key = 0; _key < _len; _key++) {
    opts[_key] = arguments[_key];
  }

  var base = Object.assign({}, baseOpt());

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = opts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var o = _step.value;

      merge$1(base, o);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return base;
};

var StandardDispatchers = {
    Rendered: 'rendered'
};

var initOpt = function initOpt(userOpt, composer) {
    var opt = composer.opt;


    if (typeof opt === 'function') {
        return opt(userOpt);
    } else if (Array.isArray(opt)) {
        return mergeOptions.apply(undefined, toConsumableArray(opt).concat([userOpt]));
    } else {
        return mergeOptions(opt, userOpt);
    }
};

var initState = function initState(containerId, opt, composers) {
    return {
        _isMobileSize: isMobile(),
        _id: uuid(),
        _listeners: dispatch(Object.values(StandardDispatchers)),
        _options: assignContainerBound(containerId, initOpt(opt, composers)),
        _data: [],
        _color: null,
        _container: null,
        _containerId: containerId,
        _composers: composers
    };
};

var svgLayer = function svgLayer(containerId, opt, composers) {
  var state = initState(containerId, opt, makeComposers(composers));

  return Object.assign(state, apiOn(state), apiColor(state), apiOptions(state), apiData(state), apiRender(state), apiUpdate(state));
};

var apiRender$1 = function apiRender$$1(state) {
  return {
    render: function render(data) {
      apiRender(state).render(data);

      var container = state._container,
          containerId = state._containerId,
          frontCanvasId = state._frontCanvasId,
          hiddenCanvasId = state._hiddenCanvasId,
          opts = state._options;


      container.style('position', 'absolute').style('pointer-events', 'none');

      var detachedContainer = select(containerId).append('vizart-detached');
      var devicePixelRatio = window.devicePixelRatio || 1;
      var frontCanvas = select(containerId).append('canvas').attr('id', frontCanvasId).style('position', 'absolute').style('display', 'block').style('width', opts.chart.innerWidth + 'px').style('height', opts.chart.innerHeight + 'px').style('margin', opts.chart.margin.top + 'px 0 0 ' + opts.chart.margin.left + 'px ').attr('width', opts.chart.innerWidth * devicePixelRatio).attr('height', opts.chart.innerHeight * devicePixelRatio);

      var hiddenCanvas = select(containerId).append('canvas').attr('id', hiddenCanvasId).style('position', 'absolute').style('display', 'none').style('width', opts.chart.innerWidth + 'px').style('height', opts.chart.innerHeight + 'px').style('margin', opts.chart.margin.top + 'px 0 0 ' + opts.chart.margin.left + 'px ').attr('width', opts.chart.innerWidth * devicePixelRatio).attr('height', opts.chart.innerHeight * devicePixelRatio);

      var hiddenContext = hiddenCanvas.node().getContext('2d');
      var frontContext = frontCanvas.node().getContext('2d');

      hiddenContext.mozImageSmoothingEnabled = false;
      hiddenContext.webkitImageSmoothingEnabled = false;
      hiddenContext.msImageSmoothingEnabled = false;
      hiddenContext.imageSmoothingEnabled = false;

      var backingStoreRatio = frontContext.webkitBackingStorePixelRatio || frontContext.mozBackingStorePixelRatio || frontContext.msBackingStorePixelRatio || frontContext.oBackingStorePixelRatio || frontContext.backingStorePixelRatio || 1;

      var ratio = devicePixelRatio / backingStoreRatio;
      var canvasScale = ratio;
      frontContext.scale(ratio, ratio);
      hiddenContext.scale(ratio, ratio);

      state._frontCanvas = frontCanvas;
      state._hiddenCanvas = hiddenCanvas;
      state._frontContext = frontContext;
      state._hiddenContext = hiddenContext;
      state._canvasScale = canvasScale;
      state._detachedContainer = detachedContainer;
    }
  };
};

var drawCell = function drawCell(context, cell) {
  if (!cell) return false;
  context.moveTo(cell[0][0], cell[0][1]);
  for (var j = 1, m = cell.length; j < m; ++j) {
    context.lineTo(cell[j][0], cell[j][1]);
  }
  context.closePath();
  return true;
};

var drawVoronoi = function drawVoronoi(context, diagram, color) {
  context.save();
  var polygons = diagram.polygons();

  context.beginPath();
  context.lineWidth = 1;
  context.strokeStyle = color;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = polygons[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var p = _step.value;

      drawCell(context, p);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  context.stroke();
  context.closePath();
  context.restore();
};

var applyVoronoi = function applyVoronoi(context, opt, finalState) {
  var voronoiDiagram = voronoi().x(function (d) {
    return d.x;
  }).y(function (d) {
    return d.y;
  }).extent([[-1, -1], [context.canvas.width + 1, context.canvas.height + 1]]);

  return voronoiDiagram(finalState);
};

/**
 * Collapse the quadtree into an array of rectangles.
 *
 * @param quadtree
 * @returns {Array}
 */
var flattenQuadtree = function flattenQuadtree(quadtree$$1) {
  var nodes = [];
  quadtree$$1.visit(function (node, x0, y0, x1, y1) {
    node.x0 = x0, node.y0 = y0;
    node.x1 = x1, node.y1 = y1;
    nodes.push(node);
  });
  return nodes;
};

var drawQuadtree = function drawQuadtree(context, diagram, color) {
  context.save();
  var rects = flattenQuadtree(diagram);

  context.beginPath();
  context.lineWidth = 1;
  context.strokeStyle = color;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = rects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var r = _step.value;

      context.strokeRect(r.x0, r.y0, r.x1 - r.x0, r.y1 - r.y0);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  context.stroke();
  context.closePath();

  context.restore();
};

var applyQuadtree = function applyQuadtree(context, opt, finalState) {
  return quadtree().x(function (d) {
    return d.x;
  }).y(function (d) {
    return d.y;
  }).extent([[-1, -1], [context.canvas.width + 1, context.canvas.height + 1]]).addAll(finalState);
};

/**
 * Adjusted from: http://blog.graphicsgen.com/2015/03/html5-canvas-rounded-text.html
 *
 * @param ctx
 * @param text
 * @param fontSize
 * @param titleFont
 * @param centerX
 * @param centerY
 * @param radius
 * @param startAngle In degrees, Where the text will be shown. 0 degrees if the top of the circle
 * @param kerning 0 for normal gap between letters. Positive or negative number to expand/compact gap in pixels
 * @param textAlpha
 */
var drawCircularText = function drawCircularText(ctx, text, fontSize, titleFont, color, centerX, centerY, radius, startAngle, kerning) {
  //Setup letters and positioning
  ctx.textBaseline = 'alphabetic';
  ctx.textAlign = 'center'; // Ensure we draw in exact center
  ctx.font = fontSize + 'px ' + titleFont;
  ctx.fillStyle = color;

  // startAngle = startAngle * (Math.PI / 180); // convert to radians
  text = text.split('').reverse().join(''); // Reverse letters

  //Rotate 50% of total angle for center alignment
  for (var j = 0; j < text.length; j++) {
    var charWid = ctx.measureText(text[j]).width;
    startAngle += (charWid + (j === text.length - 1 ? 0 : kerning)) / radius / 2;
  } //for j

  ctx.save(); //Save the default state before doing any transformations
  ctx.translate(centerX, centerY); // Move to center
  ctx.rotate(startAngle); //Rotate into final start position

  //Now for the fun bit: draw, rotate, and repeat
  for (var _j = 0; _j < text.length; _j++) {
    var _charWid = ctx.measureText(text[_j]).width / 2; // half letter
    //Rotate half letter
    ctx.rotate(-_charWid / radius);
    //Draw the character at "top" or "bottom" depending on inward or outward facing
    ctx.fillText(text[_j], 0, -radius);
    //Rotate half letter
    ctx.rotate(-(_charWid + kerning) / radius);
  } //for j

  ctx.restore(); //Restore to state as it was before transformations
}; //function drawCircularText

/**
 * Generates the next color in the sequence, going from 0,0,0 to 255,255,255.
 * via http://stackoverflow.com/a/15804183
 *
 * @param dataIndex
 * @returns {string}
 */
var genColorByIndex = function genColorByIndex(dataIndex) {
  var ret = [];
  if (dataIndex < 16777215) {
    ret.push(dataIndex & 0xff); // R
    ret.push((dataIndex & 0xff00) >> 8); // G
    ret.push((dataIndex & 0xff0000) >> 16); // B
  }
  return 'rgb(' + ret.join(',') + ')';
};

/**
 * add linear gradient, x0, y0 -> x1, y1
 *
 * @param context CanvasRenderingContext2D
 * @param scheme color scheme
 * @param opacity fill opacity
 */
var radialGradient = function radialGradient(context, scheme, opacity, centerX, centerY, innerRadius, outerRadius) {
  var grd = context.createRadialGradient(centerX, centerY, innerRadius, centerX, centerY, outerRadius);

  var stops = linearStops(scheme, opacity);
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = stops[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref2 = _step.value;
      var offset = _ref2.offset,
          color = _ref2.color;

      grd.addColorStop(offset, color);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return grd;
};

/**
 * add linear gradient, x0, y0 -> x1, y1
 *
 * @param context CanvasRenderingContext2D
 * @param scheme color scheme
 * @param opacity fill opacity
 */
var verticalGradient = function verticalGradient(context, scheme) {
  var opacity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  var grd = context.createLinearGradient(context.canvas.clientWidth / 2, context.canvas.clientHeight, context.canvas.clientWidth / 2, 0);

  var stops = linearStops(scheme);

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = stops[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref2 = _step.value;
      var offset = _ref2.offset,
          color = _ref2.color;

      if (opacity < 1) {
        var hslColor = hsl(color);
        hslColor.opacity = opacity;
        grd.addColorStop(offset, hslColor);
      } else {
        grd.addColorStop(offset, color);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return grd;
};

var apiRevealVoronoi = function apiRevealVoronoi(state) {
  return {
    revealVoronoi: function revealVoronoi() {
      var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#ff5730';

      if (!state.hasOwnProperty(state, '_voronoi')) {
        console.error('voronoi is not enabled in chart');
        return;
      }

      drawVoronoi(state._frontContext, state._voronoi, color);
    }
  };
};

var apiRevealQuadtree = function apiRevealQuadtree(state) {
  return {
    revealQuadtree: function revealQuadtree() {
      var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#1f97e7';

      if (!state.hasOwnProperty(state, '_quadtree')) {
        console.error('quadtree is not enabled in chart');
        return;
      }

      drawQuadtree(state._frontContext, state._quadtree, color);
    }
  };
};

var CanvasState = function CanvasState() {
  return {
    _hiddenCanvasId: 'hidden-canvas' + uuid(),
    _frontCanvasId: 'front-canvas-' + uuid(),
    _frontCanvas: null,
    _hiddenCanvas: null,
    _frontContext: null,
    _hiddenContext: null,
    _detachedContainer: null,
    _voronoi: null,
    _quadtree: null,
    _animationState: null
  };
};

var canvasLayer = function canvasLayer(containerId, opt, composers) {
  var base = initState(containerId, opt, makeComposers(composers));
  var state = Object.assign(base, CanvasState());

  return Object.assign(state, apiOn(state), apiColor(state), apiOptions(state), apiData(state), apiRevealVoronoi(state), apiRevealQuadtree(state), apiRender$1(state), apiUpdate(state));
};

var compose = function compose(baseLayer, fns) {
  return fns.reduce(function (acc, cur) {
    acc = Object.assign(acc, cur(acc));
    return acc;
  }, baseLayer);
};

var factory = function factory(baseLayer, composers, apis) {
  return function (id, opt) {
    return compose(baseLayer(id, opt, composers), apis);
  };
};

var _compose = function _compose(f, g) {
  return function () {
    return f(g.apply(undefined, arguments));
  };
};

var compose$1 = function compose() {
  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return fns.reduce(_compose);
};
var pipe = function pipe() {
  for (var _len2 = arguments.length, fns = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }

  return compose$1.apply(compose$1, fns.reverse());
};

var DefaultSequentialColor = {
  scheme: MetroRain3,
  type: Globals.ColorType.GRADIENT
};

var DefaultCategoricalColor = {
  scheme: TheMetLight,
  type: Globals.ColorType.CATEGORICAL
};

//Taken from http://bl.ocks.org/mbostock/7555321
//Wraps SVG text
var wrapSVGText = function wrapSVGText(text, width) {
  text.each(function () {
    var text = select(this),
        words = text.text().split(/\s+/).reverse(),
        word = void 0,
        line = [],
        lineNumber = 0,
        lineHeight = 1.4,
        // ems
    y = text.attr('y'),
        x = text.attr('x'),
        dy = parseFloat(text.attr('dy')),
        tspan = text.text(null).append('tspan').attr('x', x).attr('y', y).attr('dy', dy + 'em');

    while (word = words.pop()) {
      line.push(word);
      tspan.text(line.join(' '));
      if (tspan.node().getComputedTextLength() > width) {
        line.pop();
        tspan.text(line.join(' '));
        line = [word];
        tspan = text.append('tspan').attr('x', x).attr('y', y).attr('dy', ++lineNumber * lineHeight + dy + 'em').text(word);
      }
    }
  });
};

//Wraps SVG text - Taken from http://bl.ocks.org/mbostock/7555321
var wrapTextSmaller = function wrapTextSmaller(text, width) {
  var _text = select(text),
      words = _text.text().split(/\s+/).reverse(),
      currentSize = +_text.style('font-size').replace('px', ''),
      word = void 0,
      line = [],
      lineNumber = 0,
      lineHeight = 1.2,
      // ems
  extraHeight = 0.2,
      y = _text.attr('y'),
      dy = parseFloat(_text.attr('dy')),

  //First span is different - smaller font
  tspan = _text.text(null).append('tspan').attr('class', 'subTotal').attr('x', 0).attr('y', y).attr('dy', dy + 'em').style('font-size', (Math.round(currentSize * 0.5) <= 5 ? 0 : Math.round(currentSize * 0.5)) + 'px');
  while (word = words.pop()) {
    line.push(word);
    tspan.text(line.join(' '));
    if (tspan.node().getComputedTextLength() > width | word === '|') {
      if (word = '|') word = '';
      line.pop();
      tspan.text(line.join(' '));
      line = [word];
      tspan = _text.append('tspan').attr('x', 0).attr('y', y).attr('dy', ++lineNumber * lineHeight + extraHeight + dy + 'em').text(word);
    } //if
  } //while
}; //wrap

// Given a text function and width function, truncates the text if necessary to
// fit within the given width.
var truncate = function truncate(text, width) {
  return function (d, i) {
    var t = this.textContent = text(d, i),
        w = width(d, i);
    if (this.getComputedTextLength() < w) return t;
    this.textContent = '…' + t;
    var lo = 0,
        hi = t.length + 1,
        x = void 0;
    while (lo < hi) {
      var mid = lo + hi >> 1;
      if ((x = this.getSubStringLength(0, mid)) < w) lo = mid + 1;else hi = mid;
    }
    return lo > 1 ? t.substr(0, lo - 2) + '…' : '';
  };
};

var transparent = function transparent(c, alpha) {
  var hslColorSpace = hsl(c);
  hslColorSpace.opacity = alpha;

  return hslColorSpace;
};

export { version, svgLayer, canvasLayer, Globals, factory, compose$1 as compose, pipe, linearStops, SchemeAccent, SchemeDark2, SchemePaired, SchemePastel1, SchemePastel2, SchemeSet1, SchemeSet2, SchemeSet3, SchemeCategory10, SchemeReds, SchemeBlues, SchemeGreens, SchemeGreys, SchemeOranges, SchemePurples, SchemeBuGn, SchemeBuPu, SchemeGnBu, SchemeOrRd, SchemePuBuGn, SchemePuBu, SchemePuRd, SchemeRdPu, SchemeYlGnBu, SchemeYlGn, SchemeYlOrBr, SchemeYlOrRd, SchemeViridis, SchemeInferno, SchemeMagma, SchemePlasma, SchemeWarm, SchemeCool, SchemeRainbow, SchemeCubehelix, SchemeBrBG, SchemePRGn, SchemePiYG, SchemePuOr, SchemeRdBu, SchemeRdGy, SchemeRdYlBu, SchemeRdYlGn, SchemeSpectral, AllHcl, DefaultColorSpace, ColorBlind, FancyLight, FancyDark, Tarnish, Pastel, Pimp, Intense, Fluo, RedRoses, OchreSand, IndigoNight, YellowLime, GreenMint, IceCube, BlueOcean, PurpleWine, MetroCold3, MetroCold4, MetroCold5, MetroDawn3, MetroDawn4, MetroRain3, MetroRain8, TheMetDark, TheMetLight, gradientColor, distinctColor, divergentColor, categoricalColor, genericColor, mergeOptions, DefaultSequentialColor, DefaultCategoricalColor, isMobile, truncate as truncateSvgText, uuid, transparent as getTransparentColor, wrapSVGText, wrapTextSmaller, drawVoronoi, applyVoronoi, drawQuadtree, applyQuadtree, drawCircularText, genColorByIndex, radialGradient, verticalGradient, apiRender as apiRenderSVG, apiRender$1 as apiRenderCanvas, apiUpdate };
//# sourceMappingURL=vizart-core.esm.js.map
